// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"sass_mainBox__1TO4s","main":"sass_main__1mf7Z","loading":"sass_loading__31716","icp":"sass_icp__1p0lJ"};